export default "__VITE_ASSET__BCAcBLHu__"